<template>
	<div>
		<BlockEditorWidgetFieldSettings
			v-if="editField && sideBarFocus === 'form'"
			:key="editField.id"
			:previousSteps="previousSteps"
			:isGeneralConfiguration="isGeneralConfiguration"
			:isConfigurationEditMode="isConfigurationEditMode"
		/>
		<WidgetTitleSettings v-on="$listeners" v-else-if="sideBarFocus === 'title'" />
		<WidgetPageOptions v-on="$listeners" v-else-if="sideBarFocus === 'options'" />
		<BlockEditorWidgetPlaceHolder v-else :isPdfViewer="isFileViewerActive && sideBarFocus === 'pdf'" />
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import WidgetPageOptions from './FieldSettings/WidgetPageOptions';
import WidgetTitleSettings from './FieldSettings/WidgetTitleSettings';
import BlockEditorWidgetPlaceHolder from './BlockEditorWidgetPlaceHolder';
import BlockEditorWidgetFieldSettings from './BlockEditorWidgetFieldSettings';

export default {
	name: 'WidgetSideBarSettings',
	components: {
		WidgetPageOptions,
		WidgetTitleSettings,
		BlockEditorWidgetPlaceHolder,
		BlockEditorWidgetFieldSettings,
	},
	props: {
		sideBarFocus: { type: String },
		previousSteps: { type: Object },
		isGeneralConfiguration: { type: Boolean },
		isConfigurationEditMode: { type: Boolean },
	},
	computed: {
		...mapGetters('widgetEditor', ['widget', 'editField', 'widgetMetadata']),
		isFileViewerActive() {
			return ((this.widgetMetadata.options || {}).file_viewer || {}).active;
		},
	},
};
</script>
